import React, { useEffect, useMemo, useRef, useState } from "react";
import AddIcon from "resources/img/Icon-add.svg";
import RemoveIcon from "resources/img/remove-icon.svg";
import Inactive86Label from "./components/Inactive86Label";
import {
  ProductCounter,
  SimpleImgContainer,
  Img,
  Price,
  Title,
  TitleContainer,
  SimpleCard,
  VariantContainer,
  VariantName,
  VariantPrice,
} from "./product-styles";
import styled from "styled-components";

const CustomTitleContainer = styled(TitleContainer)`
  height: 110%;
  padding-left: 10px;
  width: unset;
  flex-grow: 1;
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CustomTitle = styled(Title)`
  max-width: 100%;
  padding-right: 10px;
  white-space: nowrap;
  font-size: 16px;
  transition-duration: .4s;  
  align-self: center;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 17px;
  height: 17px;

  &.is-displayed {
    white-space: break-spaces;
    font-size: 14px;
    line-height: 15px;
    height: 100%;
    box-sizing: content-box;

    &&::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Product = ({
  title,
  handleSelection,
  isOrdered,
  amounts,
  variants,
  remove,
  is86Inactive,
  perVariant = false,
  variantId,
  config,
}) => {

  const amount = useMemo(() => {
    return perVariant ?
      amounts.find(variant => +variant.id === +variantId)?.count || 0 :
      amounts?.reduce((count, variantAmount) => count += +variantAmount.count, 0) || 0;
  }, [amounts]);

  const [isTitleDisplayed, setIsTitleDisplayed] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const titleRef = useRef(null);

  useEffect(() => {
    if (titleRef.current) {
      setIsOverflowing(titleRef.current.scrollWidth > titleRef.current.clientWidth);
    }
  }, [title]);

  const onChangeDisplay = () => {
    if (!isOverflowing && !isTitleDisplayed) return;
    setIsTitleDisplayed(!isTitleDisplayed);
  }

  const variant = useMemo(() => {
    return perVariant ?
      variants.find(variant => variant.id === variantId) :
      variants?.length ? variants[0] : null;
  }, [variantId, variants]);

  return (
    <SimpleCard isSelected={isOrdered} className="simple-product-card-container">
      <CustomTitleContainer onClick={onChangeDisplay}>
        <CustomTitle ref={titleRef} isTitleDisplayed={isTitleDisplayed} className={isTitleDisplayed ? 'is-displayed' : ''}>{title}</CustomTitle>
      </CustomTitleContainer>
      {variants?.length < 2 && <Price>{config?.marketPrice ? 'MKT' : `$${variants[0].price}`}</Price>}
      {perVariant && variants.length > 1 && !!variant.active && (
        <div style={{ marginTop: "5px" }}>
          <VariantContainer>
            <VariantName>{variant.title}</VariantName>
            <VariantPrice>{config?.marketPrice ? 'MKT' : `$${variant.price}`}</VariantPrice>
          </VariantContainer>
        </div>
      )}
      {
         !perVariant && variants?.length > 1 && (
          <div style={{ marginTop: "5px", marginBottom: "5px" }}>
            {
              variants.map((variant, index) => (
                <VariantContainer key={index}>
                  {!!variant.active && (<>
                    <VariantName>{variant.title}</VariantName>
                    <VariantPrice>{config?.marketPrice ? 'MKT' : `$${variant.price}`}</VariantPrice>
                  </>)}                  
                </VariantContainer>
              ))
            }
          </div>
        )
      }
      {is86Inactive ? (
        <Inactive86Label/>
      ) : (
        <SimpleImgContainer>
          {isOrdered && !!amount && <ProductCounter>{amount}</ProductCounter>}
          <Img src={remove ? RemoveIcon : AddIcon} onClick={() => handleSelection(variant?.id, remove)}  />
        </SimpleImgContainer>
      )}
    </SimpleCard>
  );
};

export default Product;